module.exports = __webpack_public_path__ + "media/images/logos/microsoft_outlook-53aaa9fb9b4335adacebe82ab4d09834.svg";